module.exports = __webpack_public_path__ + "img/jcd_logo.288e2732.png";